export default function InnerCard(props: { children: React.ReactNode }) {
  return (
    <div className=" border border-solid border-gray-200 rounded-[8px] bg-white px-4 py-4">
      {props.children}
    </div>
  )
}
